const SEAFOOD_PLAN_KEY = "seafood-plan";

const BOX_WEEKS_TO_PLAN_ID = new Map();
BOX_WEEKS_TO_PLAN_ID.set("4", "693379957010");
BOX_WEEKS_TO_PLAN_ID.set("6", "693380022546");
BOX_WEEKS_TO_PLAN_ID.set("8", "693380088082");

const SEAFOOD_TYPE_TO_PRODUCT_HANDLE = new Map();
SEAFOOD_TYPE_TO_PRODUCT_HANDLE.set("salmon", "wild-caught-alaskan-salmon-box");
SEAFOOD_TYPE_TO_PRODUCT_HANDLE.set(
  "whitefish",
  "wild-caught-white-fish-box",
);
SEAFOOD_TYPE_TO_PRODUCT_HANDLE.set(
  "crab",
  "alaskan-crab-variety-subscription-box",
);
SEAFOOD_TYPE_TO_PRODUCT_HANDLE.set(
  "fishvariety",
  "wild-caught-alaska-seafood-subscription-6-species",
);

const productHandleToProductCache = new Map();

class SeafoodPlanData {
  constructor(storedDataString) {
    if (storedDataString) {
      const data = JSON.parse(storedDataString);
      this.discountCookie = window?.discountManager?.getActiveDiscountCookie() || data.discountCookie;
      this.seafoodType = data.seafoodType === "custom" ? "salmon" : data.seafoodType;
      this.planFrequency = data.planFrequency || 4;
      this.sellingPlanId = BOX_WEEKS_TO_PLAN_ID.get(
        String(this.planFrequency) || 4,
      );
      this.boxSize = data.boxSize;
      this.productHandle = data.seafoodType === "custom" ? "wild-caught-alaskan-salmon-box" : (SEAFOOD_TYPE_TO_PRODUCT_HANDLE.get(this.seafoodType));
    } else {
      this.seafoodType = "fishvariety"; // salmon, whitefish, crab, fishvariety
      this.planFrequency = "4"; // 4, 6, 8
      this.boxSize = "4.5 lbs"; // 4.5 lbs, 9 lbs
      this.discountCookie = window?.discountManager?.getActiveDiscountCookie() || "FREESMOKEDSALMON"; // FREEHALIBUT, FREESMOKEDSALMON, FREESALMONDIP, FREESALMONSPREAD,
      this.sellingPlanId = "693379957010"; // 693379957010, 693380022546, 693380088082
      this.productHandle = SEAFOOD_TYPE_TO_PRODUCT_HANDLE.get(this.seafoodType); // alaskan-whitefish-subscription-box, alaskan-crab-variety-subscription-box, alaskan-fish-variety-subscription-box
    }
  }

  selectBoxSize(boxSize) {
    this.boxSize = boxSize;
    sessionStorage.setItem(SEAFOOD_PLAN_KEY, JSON.stringify(this));
  }

  selectSeafood(seafoodType) {
    this.seafoodType = seafoodType;
    this.productHandle = SEAFOOD_TYPE_TO_PRODUCT_HANDLE.get(seafoodType);
    sessionStorage.setItem(SEAFOOD_PLAN_KEY, JSON.stringify(this));
  }

  selectDiscountCookie(cookie) {
    this.discountCookie = cookie;
    sessionStorage.setItem(SEAFOOD_PLAN_KEY, JSON.stringify(this));
  }

  selectPlanFrequency(planFrequency) {
    this.planFrequency = planFrequency;
    this.sellingPlanId = BOX_WEEKS_TO_PLAN_ID.get(
      String(this.planFrequency) || 4,
    );

    sessionStorage.setItem(SEAFOOD_PLAN_KEY, JSON.stringify(this));
  }
}

function lookForDiscountManager(resolve) {
  if (window?.discountManager) {
    resolve();
  } else {
    setTimeout(() => {
      lookForDiscountManager(resolve);
    }, 100);
  }
}
new Promise((resolve) => {
lookForDiscountManager(resolve);
}).then(()=> {


const seafoodPlanData = new SeafoodPlanData(
  sessionStorage.getItem(SEAFOOD_PLAN_KEY),
);
$(document).ready(function () {
  /*******************************************
   * State
   *******************************************/
  /*******************************************
   * Seafood Plan Logic
   *******************************************/
  // Listen for seafood selection
  $("input[name='seafood']").on("click", async function () {
    var seafoodType = $("input[name=seafood]:checked").val();
    seafoodPlanData.selectSeafood(seafoodType);

    showCorrectSectionsForSeafoodPlan(seafoodType);

    if (seafoodType !== "custom") {
      document
        .querySelector("#seafood-freebie")
        .scrollIntoView({ behavior: "smooth" });

      const product = await getProductPlanInfo();
      if (product) {
        updateBoxSizeCards(product);
      } else {
        console.error(
          "Failed to fetch product for ",
          seafoodPlanData.productHandle,
        );
      }
    }
  });

  function showCorrectSectionsForSeafoodPlan(seafoodType) {
    if (seafoodType === "custom") {
      const customBoxButton = document.querySelector(
        ".mainButtonArea .custom-box-button",
      );
      customBoxButton.classList.remove("hidden");
      const checkoutButton = document.querySelector(
        ".mainButtonArea .checkout-button",
      );
      checkoutButton.classList.add("hidden");
      const boxSizeSection = document.getElementById("sub-order-summary");
      boxSizeSection.classList.add("hidden");
      const freebieSection = document.getElementById("freebie-area");
      freebieSection?.classList.add("hidden");
    } else {
      const customBoxButton = document.querySelector(
        ".mainButtonArea .custom-box-button",
      );
      customBoxButton.classList.add("hidden");
      const checkoutButton = document.querySelector(
        ".mainButtonArea .checkout-button",
      );
      checkoutButton.classList.remove("hidden");
      const boxSizeSection = document.getElementById("sub-order-summary");
      boxSizeSection.classList.remove("hidden");
      const freebieSection = document.getElementById("freebie-area");
      freebieSection?.classList.remove("hidden");
    }
  }

  /*******************************************
   * Box Size & Schedule Logic
   *******************************************/
  $(document).on("click", ".changeTime", function () {
    $(".changeTime").hide();
    $(".time-links").show();
  });

  // On selecting a frequency option
  $(document).on("click", ".time-link", async function () {
    var weeks = $(this).data("weeks");
    seafoodPlanData.selectPlanFrequency(weeks);
    $(".time-links").hide();
    $(".changeTime").show();
    const product = await getProductPlanInfo();
    if (product) {
      updateBoxSizeCards(product);
    } else {
      console.error(
        "Failed to fetch product for ",
        seafoodPlanData.productHandle,
      );
    }
  });

  $(document).on(" click", "input[name='boxsize']", function (e, others) {
    var variantId = $("input[name=boxsize]:checked").val();
    seafoodPlanData.selectBoxSize(variantId);

    if (!others?.isScriptedClick) {
      document.querySelector('.mainButtonArea .continueButton').classList.add('ready') 
    }
  });

  async function getProductPlanInfo() {
    console.log("getProductPlanInfo", seafoodPlanData.productHandle);
    if (productHandleToProductCache.has(seafoodPlanData.productHandle)) {
      return productHandleToProductCache.get(seafoodPlanData.productHandle);
    }

    const productHandleUrl =
      window.Shopify.routes.root +
      "products/" +
      seafoodPlanData.productHandle +
      ".js";

    try {
      const response = await fetch(productHandleUrl, { method: "GET" });
      const product = await response.json();

      if (!product) {
        throw new Error("Product not found");
      }
      productHandleToProductCache.set(seafoodPlanData.productHandle, product);
      return product;
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  }

  /*******************************************
   * Freebie Logic
   *******************************************/

  // Listen for freebie selection
  $("input[name='offer-value']").on("click", function () {
    var offerChoice = $("input[name='offer-value']:checked").val();
    onFreebieSelected(offerChoice);
          document
        .querySelector("#sub-order-summary")
        .scrollIntoView({ behavior: "smooth" });
      
  });

  async function onFreebieSelected(offerChoice) {
      

    if (offerChoice === "affiliate") {
      // This only happens if the user has an affiliate discount code and then selects a different offer.
      // and then selects the affiliate offer again.
      seafoodPlanData.selectDiscountCookie(offerChoice);
      window.discountManager.setDiscountCode("affiliate");
    } else {
      const discountInfo =
        window.discountManager.discountCookieToInfoMap.get(offerChoice);
      seafoodPlanData.selectDiscountCookie(offerChoice);

      window.discountManager.setDiscountCode(discountInfo.urlPath);
    }


    const product = await getProductPlanInfo();
    if (product) {
      updateBoxSizeCards(product);
    } else {
      console.error(
        "Failed to fetch product for ",
        seafoodPlanData.productHandle,
      );
    }
  }

  function setupAffilateDiscountCard() {
    const affilateCard = $(".sub-select-card.affiliate");
    affilateCard.removeClass("hidden");
    const nameElem = affilateCard.find("[data-affiliate-property='name'] span");
    const descriptionElem = affilateCard.find(
      "[data-affiliate-property='description'] span",
    );

    descriptionElem.text("Your promotional discount will apply at checkout.");
    nameElem.text("Special Promo");

    $(".sub-select-card.affiliate input").prop("checked", true);
    onFreebieSelected("affiliate");
  }

  /*******************************************
   * Page Setup Logic
   *******************************************/
  function selectDefaultFreebieCard() {
    console.log("default freebie: discount info map: ", window.discountManager.discountCookieToInfoMap);
    var free_offer_param = window.NttUtils.getUrlParameter("freeoffer");

    // Priority: URL | COOKIE | STORAGE | DEFAULT
    var defaultDiscountVal =
      (free_offer_param? free_offer_param.toUpperCase() : undefined) ||
      window.discountManager.getActiveDiscountCookie() ||
      seafoodPlanData.discountCookie;
      console.log('default discount val:', defaultDiscountVal);
    const discountInfo =
      window.discountManager.discountCookieToInfoMap.get(defaultDiscountVal);

    window.discountManager.setDiscountCode(discountInfo.urlPath);
    if (discountInfo) {
      $(".sub-select-card." + (discountInfo.name || "") + " input").prop(
        "checked",
        true,
      );
    }
    onFreebieSelected(window.discountManager.currentDiscount);
  }

  function setupFreebieDefaults() {
    if (window.discountManager.hasAffiliateCode()) {
      setupAffilateDiscountCard();
    } else {
      selectDefaultFreebieCard();
    }
  }

  function setupDefaultSeafoodPlanCards() {
    const seafoodPlanData = new SeafoodPlanData(
      sessionStorage.getItem(SEAFOOD_PLAN_KEY),
    );
    console.log("seafood plan data from storage is:", seafoodPlanData);

    let seafoodType = seafoodPlanData.seafoodType;
    console.log("seafoodType", seafoodType)
    // var seafoodParam = getUrlParameter("seafoodtype");
    // console.log("seafoodparam:", seafoodParam);

    // if (seafoodParam) {
    //   seafoodType = seafoodParam;
    // }

    // if (seafoodType === "custom") {
    //   seafoodType = "salmon";
    // }
    
    // if (!seafoodType) {
    //   seafoodType = "fishvariety";
    // }
        console.log("seafoodType", seafoodType)
    console.log("trying to select seafood type:", seafoodType, $(".sub-select-card." + seafoodType + " input"))

    $(".sub-select-card." + seafoodType + " input").prop("checked", true);

    seafoodPlanData.selectSeafood(seafoodType);
    showCorrectSectionsForSeafoodPlan(seafoodType);
  }

  async function setupDefaultBoxSizeCards() {
    console.log("setupDefaultBoxSizeCards");
    $(".time-links").hide();
    const product = await getProductPlanInfo();
    if (product) {
      updateBoxSizeCards(product);
    } else {
      console.error(
        "Failed to fetch product for ",
        seafoodPlanData.productHandle,
      );
    }
  }

  function setupDefaults() {
    setupDefaultSeafoodPlanCards();
    setupDefaultBoxSizeCards();
    if (document.querySelector(".freebie-section")) {
      setupFreebieDefaults();
    } 
  }

  /*******************************************
   * Checkout Logic
   *******************************************/
  $(".checkout-button").click(async function () {
    // clear the cart b/c it might have old "freebie" products that are no longer free.
    await window.NttUtils.clearCart();

    await window.discountManager.applyCurrentDiscount();

    var items = [];

    // add the seafood plan to the cart
    items.push({
      id: seafoodPlanData.boxSize,
      quantity: 1,
      selling_plan: seafoodPlanData.sellingPlanId,
    });

    // Add the family owens insert to the cart
    items.push({ id: "50989025853714", quantity: 1 });

    await window.NttUtils.addItemsToCart(items);

    location.href = "/checkout";
  });

  /*******************************************
   * UI Manipulation Functions
   *******************************************/
  function updateBoxSizeCards(product) {
    $("#product-customizer-cards").html("");

    const skioSellingPlanGroups = product.selling_plan_groups.filter(
      (group) => group.app_id === "SKIO",
    );

    for (var i = 0; i < product.variants.length; i++) {
      buildBoxSizeCard(product, product.variants[i], skioSellingPlanGroups);
    }

    // Select the correct box size card since we cleared it
    if (
      seafoodPlanData.boxSize !== null &&
      $("#" + seafoodPlanData.boxSize).length != 0
    ) {
      $("#" + seafoodPlanData.boxSize)
        .prop("checked", true)
        .trigger("click", [{ isScriptedClick: true }]);
    } else {
      $("#product-customizer-cards .sub-select-card:first-child input")
        .prop("checked", true)
        .trigger("click", [{ isScriptedClick: true }]);
    }

    // Show 20% off if applicable
    if (window.discountManager.getActiveDiscountCookie() === "WELCOME20") {
      $(".additional20").removeClass("hidden");
    }
  }

  function buildBoxSizeCard(product, variant, skioSellingPlanGroups) {
    if (!variant.available) {
      return;
    }

    var active_selling_plan = null;

    for (var j = 0; j < variant.selling_plan_allocations.length; j++) {
      var alloc = variant.selling_plan_allocations[j];
      const isSkio = skioSellingPlanGroups.some(
        (group) => group.id === alloc.selling_plan_group_id,
      );

      if (
        String(alloc.selling_plan_id) == seafoodPlanData.sellingPlanId &&
        isSkio
      ) {
        active_selling_plan = variant.selling_plan_allocations[j];
      }
    }

    if (!active_selling_plan) {
      return;
    }

    var timeFrame = "Every " + seafoodPlanData.planFrequency + " weeks";

    switch (seafoodPlanData.planFrequency) {
      case "4":
        timeFrame = "Every month";
        break;
      case "8":
        timeFrame = "Every Other Month";
        break;
      case "16":
        timeFrame = "Every Two Months";
        break;
    }

    var totalWeight = 0;
    var meals = 0;
    var priceExtraText = "";
    var codeCookieValue =
    location.pathname.includes("black-friday") ? "100OFF" : (
      seafoodPlanData.discountCookie ||
      window.discountManager.getActiveDiscountCookie());
    if (codeCookieValue) {
      const info =
        window.discountManager.discountCookieToInfoMap.get(codeCookieValue);
      if (info) {
        priceExtraText = info.priceDescriptor;
      }

      if (codeCookieValue == "WELCOME20") {
        active_selling_plan.price = active_selling_plan.price * 0.8;
      } else if (codeCookieValue.toLowerCase() === "100off") {
        // switch (seafoodPlanData.planFrequency) {
        //   case 4:
        //   active_selling_plan.price = active_selling_plan.price - 25;
        //   break;
        //   case 6:
        //     active_selling_plan.price = active_selling_plan.price - 18.75;
        //     break;
        //     case 8:
        //       active_selling_plan.price = active_selling_plan.price - 12.50;
        //       break;
        //   default:
        //     active_selling_plan.price = active_selling_plan.price - 25;
        //     break;
        // }        
      }
    }

    var priceNumber = active_selling_plan.price / 100;

    var priceFormatted = "$" + window.NttUtils.formatMoney(priceNumber, 0);
    var priceCompareString =
      variant.price != active_selling_plan.price
        ? "$" + window.NttUtils.formatMoney(variant.price / 100, 0)
        : "";

    if (variant.title.includes("4.5 lbs") && !variant.title.includes("Only")) {
      meals = 12;
      totalWeight = "4.5 lbs";
    } else if (variant.title.includes("9 lbs")) {
      meals = 24;
      totalWeight = "9 lbs";
    }

    if (meals > 0) {
      var packTitle = totalWeight + " " + product.title;

      $("#product-customizer-cards").loadTemplate(
        $("#box-size-card-template"),
        {
          variantId: variant.id,
          sellingPlan: seafoodPlanData.sellingPlanId,
          portions: meals,
          packTitle: packTitle,
          originalPrice: priceCompareString,
          price: priceFormatted,
          mainImage: product.featured_image,
          priceExtra: priceExtraText,
        },
        { append: true, async: true },
      );

      $("#" + seafoodPlanData.planFrequency + "weeks").addClass("active");

      $(".timeFrame").text(timeFrame);
    }
  }


  setupDefaults(seafoodPlanData);
});

});
